import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { type FeatureFlag } from './country.config';
import { CountryContext } from './country-context.service';

/** Route guard: blocks navigation when the given feature is disabled for the current country. */
export function featureGuard(feature: FeatureFlag): CanActivateFn {
  return () => {
    const context = inject(CountryContext);
    if (context.isEnabled(feature)) return true;
    return inject(Router).createUrlTree(['/']);
  };
}
